<p-button (click)="showCreateNewComparisonDialog()" label="Run New Comparison"></p-button>

<form [formGroup]="comparisonForm" (ngSubmit)="onSubmit()">
  <p-dialog
    header="New Comparison"
    [(visible)]="visible"
    (onHide)="onHide()"
    [modal]="true"
    styleClass="w-4"
  >
    <ng-template pTemplate="header">
      <span class="font-semibold">New comparison</span>
    </ng-template>

    <div class="form-group mt-3" *ngIf="visible">
      <!-- comparison type toggle -->
      <div class="flex flex-row gap-4 mb-4">
        <div class="flex align-items-center">
          <p-radioButton
            name="comparisonType"
            formControlName="comparisonType"
            value="template"
            inputId="typeTemplate"
          ></p-radioButton>
          <label for="typeTemplate" class="ml-2">Customer vs Template</label>
        </div>
        <div class="flex align-items-center">
          <p-radioButton
            name="comparisonType"
            formControlName="comparisonType"
            value="customer"
            inputId="typeCustomer"
          ></p-radioButton>
          <label for="typeCustomer" class="ml-2">Customer vs Customer</label>
        </div>
      </div>

      <!-- primary customer picker -->
      <div class="flex flex-column gap-2 py-2">
        <label>
          Customer Name
          <i
            pTooltip="Customers listed are sourced from ADO Artifacts. If not found, their configurations will have to be exported from the ADO pipeline 'Config Export'."
            class="fa-solid fa-circle-info ml-1"
          ></i>
        </label>
        <p-dropdown
          appendTo="body"
          formControlName="customer"
          [options]="customers"
          optionLabel="normalizedName"
          optionValue="normalizedName"
          [showClear]="true"
          placeholder="Select a Customer"
          [style]="{ minWidth: '100%' }"
          (onChange)="onCustomerSelection($event.value)"
        ></p-dropdown>
        <small
          *ngIf="comparisonForm.get('customer')!.invalid && comparisonForm.get('customer')!.touched"
          class="p-error"
        >Customer name is required</small
        >
      </div>

      <!-- primary customer version -->
      <div class="flex flex-column gap-2 py-2">
        <label>Customer Configuration</label>
        <p-dropdown
          appendTo="body"
          formControlName="customerConfigVersion"
          [options]="customerConfigVersions"
          optionLabel="version"
          optionValue="normalizedVersion"
          [showClear]="true"
          placeholder="Select a Configuration"
          [style]="{ minWidth: '100%' }"
        ></p-dropdown>
        <small
          *ngIf="
            comparisonForm.get('customerConfigVersion')!.invalid &&
            comparisonForm.get('customerConfigVersion')!.touched
          "
          class="p-error"
        >Configuration is required</small
        >
      </div>

      <!-- template selector (only in template mode) -->
      <div
        class="flex flex-column gap-2 py-2"
        *ngIf="comparisonForm.value.comparisonType === 'template'"
      >
        <label>
          Target Version
          <i
            pTooltip="The list of available target versions is sourced from the released configuration templates in ADO artifacts."
            class="fa-solid fa-circle-info ml-1"
          ></i>
        </label>
        <p-dropdown
          appendTo="body"
          formControlName="targetVersion"
          [options]="templateVersions"
          optionLabel="version"
          optionValue="normalizedVersion"
          [showClear]="true"
          placeholder="Select a Target Version"
          [style]="{ minWidth: '100%' }"
        ></p-dropdown>
        <small
          *ngIf="
            comparisonForm.get('targetVersion')!.invalid &&
            comparisonForm.get('targetVersion')!.touched
          "
          class="p-error"
        >Target Version is required</small
        >
      </div>

      <!-- second customer picker (only in customer-vs-customer mode) -->
      <div
        class="flex flex-column gap-2 py-2"
        *ngIf="comparisonForm.value.comparisonType === 'customer'"
      >
        <label>Second Customer Name</label>
        <p-dropdown
          appendTo="body"
          formControlName="secondCustomer"
          [options]="customers"
          optionLabel="normalizedName"
          optionValue="normalizedName"
          [showClear]="true"
          placeholder="Select a Customer"
          [style]="{ minWidth: '100%' }"
          (onChange)="onSecondCustomerSelection($event.value)"
        ></p-dropdown>
        <small
          *ngIf="
            comparisonForm.get('secondCustomer')!.invalid &&
            comparisonForm.get('secondCustomer')!.touched
          "
          class="p-error"
        >Second Customer is required</small
        >
      </div>

      <!-- second customer version -->
      <div
        class="flex flex-column gap-2 py-2"
        *ngIf="comparisonForm.value.comparisonType === 'customer'"
      >
        <label>Second Customer Configuration</label>
        <p-dropdown
          appendTo="body"
          formControlName="secondCustomerConfigVersion"
          [options]="secondCustomerConfigVersions"
          optionLabel="version"
          optionValue="normalizedVersion"
          [showClear]="true"
          placeholder="Select a Configuration"
          [style]="{ minWidth: '100%' }"
        ></p-dropdown>
        <small
          *ngIf="
            comparisonForm.get('secondCustomerConfigVersion')!.invalid &&
            comparisonForm.get('secondCustomerConfigVersion')!.touched
          "
          class="p-error"
        >Configuration is required</small
        >
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="mt-4 flex justify-end gap-2">
        <p-button
          label="Cancel"
          styleClass="p-button-outlined p-button-secondary"
          (click)="hide()"
        ></p-button>
        <p-button type="submit" label="Run" [disabled]="!canSubmit()"></p-button>
      </div>
    </ng-template>
  </p-dialog>
</form>
